import { render, staticRenderFns } from "./PrintingGroupListsList.vue?vue&type=template&id=59ec0965&scoped=true&"
import script from "./PrintingGroupListsList.vue?vue&type=script&lang=js&"
export * from "./PrintingGroupListsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec0965",
  null
  
)

export default component.exports